import React from 'react'
import { Link, useLocation } from "react-router-dom";
import './Navbar.css';

const Navbar = () => {
    let location = useLocation();
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
            <div className="container-fluid">

                <i class="fa-sharp fa-solid fa-book"></i>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname==="/"? "active": ""}`} aria-current="page" to="/">WELCOME IN RAJESTHAN</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname==="/about"? "active": ""}`} to="/about">STARTUP IN RAJESTHAN</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname==="/emailsend"? "active": ""}`} to="/emailsend">YOUR IDEAS</Link>
                        </li>
                       
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname==="/speek"? "active": ""}`} to="/speek">SCHOOL STARTUPS </Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link className={`nav-link ${location.pathname==="/contactus"? "active": ""}`} to="/contactus">CONTACT US </Link>
                        </li> */}

                    </ul>
                    <form className="d-flex"> 
                    <Link className="btn btn-primary mx-1" to="/login" role="button">Login</Link>
                    <Link className="btn btn-primary mx-1" to="/signup" role="button">Signup</Link>
                    </form>
                </div>
            </div>
        </nav>
    )
}

export default Navbar